/*
  Cloud 10 waitlist pop-up (Oct 2026). Markup: snippets/c10-waitlist.liquid. Styles: c10-waitlist.css
  The Back in Stock app (Shop Circle) fills #esc-oos-form a few seconds after the page loads;
  until it has, the pop-up shows "Loading sign-up...".
  Links ending in #waitlist (collection page buttons) open the pop-up straight away.
*/
(function () {
  'use strict';
  if (window.__c10w) return;
  window.__c10w = true;

  var modal, panel, lastFocus;

  function ready() {
    var form = document.getElementById('esc-oos-form');
    return !!(form && form.querySelector('#esc-out-of-stock-inputs, .esc-out-of-stock-title, input'));
  }

  function watchForm() {
    var loading = modal.querySelector('[data-c10w-loading]');
    var form = document.getElementById('esc-oos-form');
    if (!form || !loading) return;
    function check() {
      if (ready()) { loading.hidden = true; modal.classList.add('is-ready'); return true; }
      return false;
    }
    if (check()) return;
    var mo = new MutationObserver(function () { if (check()) mo.disconnect(); });
    mo.observe(form, { childList: true, subtree: true });
    // if the app never loads (blocked, offline), say so rather than spinning forever
    setTimeout(function () {
      if (!ready()) loading.textContent = 'Sorry, the sign-up didn’t load. Please refresh the page and try again.';
    }, 20000);
  }

  function open() {
    if (!modal) return;
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add('c10w-lock');
    void modal.offsetWidth; // let the browser register the closed state so the slide-in animates
    modal.classList.add('is-open');
    var first = ready() && modal.querySelector('#esc-oos-form input[type="email"]');
    (first || panel).focus({ preventScroll: true });
  }

  function close() {
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('c10w-lock');
    modal.hidden = true;
    if (location.hash === '#waitlist' && history.replaceState) history.replaceState(null, '', location.pathname + location.search);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function start() {
    modal = document.querySelector('[data-c10w-modal]');
    if (!modal) return;
    panel = modal.querySelector('.c10w-panel');
    // move to the end of the page so it sits above everything (the product column is sticky)
    document.body.appendChild(modal);
    watchForm();

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-c10w-open]')) { e.preventDefault(); open(); return; }
      if (t.closest('[data-c10w-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    if (location.hash === '#waitlist' || location.hash === '#esc-oos-form') open();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
